<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filtro"></i></b-button>Filtros </h3>
            
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!--b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
              <b-card-text>{{ text }}</b-card-text>-->
              <b-row>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="Nro Caja">
                      <b-form-input size="sm" id="codigoCaja" type="text" v-on:change="onFiltroChange" v-model="filtro.Caja" value="" placeholder="000"></b-form-input>
                    </b-input-group>                                  
                </b-col>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="NroTurno">
                      <b-form-input size="sm" id="nroTurno" type="text" v-on:change="onFiltroChange" v-model="filtro.Turno" value="" placeholder="000"></b-form-input>
                    </b-input-group>   
                    <!--<b-input-group size="sm" prepend="Documento">
                      <b-form-input size="sm" id="nroDocumento" type="text" v-on:change="onFiltroChange" v-model="filtro.nroDocumento" value="" placeholder="000"></b-form-input>
                    </b-input-group>-->                    
                </b-col>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="Cajera">
                      <b-form-input size="sm" id="nombreCajera" type="text" v-on:change="onFiltroChange" v-model="filtro.nombreCajera" value="" placeholder="María Perez"></b-form-input>
                    </b-input-group>                 </b-col>
                <b-col sm="3" class="text-center">
                        <b-button title="Aplicar filtro" :class="{'btn btn-success' :filtroActivo, 'btn btn-light':!filtroActivo}" @click="aplicarFiltro()"><i :class="{'fas fa-check':filtroActivo,'fas fa-ban':!filtroActivo}"></i></b-button>
                        <b-button title="Resetear filtro" variant="primary" @click="resetFiltro()"><i class="fas fa-undo"></i></b-button>
                </b-col>
              </b-row>
              <b-row>
                  <b-col sm="3">
                    <b-form-input class="form-control form-control-sm float-right" id="fecha" type="date" v-on:change="onFiltroChange" v-model="filtro.fecha" name="fecha" min="01-01-2000"
              max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <b-button size="sm" @click="cierreTotal()" block  variant="success">cierre Caja</b-button>
                  </b-col>
                  <b-col sm="3">
                    <b-button size="sm" @click="turnosProcesados()" block  variant="success">Turnos Procesados</b-button>
                  </b-col>                                                                       
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </base-header>    
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>

    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">Arqueos de Caja</h3>
        </b-card-header>
        <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <tbody>
                    <tr class="thead-light text-center">
                        <th>Cod. Caja</th>
                        <!--<th>Consecutivo</th>
                        <th>Fact. Al Mayor</th>-->
                        <th v-if="$gate.isAdmin()">Tienda</th>
                        <th>Área</th>
                        <!--<th>Cajer@ En Turno</th>-->
                        <th>Estatus Actual</th>
                        <!--<th class="text-right">Monto Recaudado Bs</th>
                        <th class="text-right">Monto Recaudado $</th>-->
                        <th>Acciones</th>
                  </tr>
                  <tr class="text-center" v-for="caja in cajas" :key="caja.codigoCaja">
                    <td><h3><b-badge variant="primary">{{caja.codigoCaja}}</b-badge></h3></td>
                    <!--<td>{{zfill(caja.consecutivo, 6)}}</td>
                    <td><span :class="{'badge badge-danger':!caja.TurnoAlMayor, 'badge badge-success':caja.facturaAlMayor }">{{caja.facturaAlMayor | factmy}}</span></td>-->
                    <td v-if="$gate.isAdmin()">{{caja.nombreTienda}}</td>
                    <td>{{caja.area}}</td>
                    <!--<td></td>-->
                    <td><span :class="{'badge badge-danger':!caja.estatusActual, 'badge badge-success':caja.estatusActual }">{{caja.estatusActual | status}}</span></td>                    
                    <!--<td class="text-right"><h3>{{caja.totalfacturadobs | moneda}}</h3></td>
                    <td class="text-right"><h3>{{caja.totalfacturadodolar | moneda}}</h3></td>-->
                    <td>                    
                        <base-button size="sm" title="Ver Turno Caja" type="secondary" 
                        @click="procesarCaja(caja)"
                        :class="{'disabled':(caja.estatus == -1 || caja.estatus == 0)}">
                            <i class="fas fa-eye"></i>
                        </base-button>                        
                        <!--<base-button size="sm" type="warning" @click="editModal(caja)">
                            <i class="fa fa-edit"></i>
                        </base-button>-->
                        
                        <base-button v-if="$gate.isAllAdminOrUsers()"  size="sm" type="info" @click="detalleCaja(caja)">
                            <i class="fa fa-money-check-alt"></i>
                        </base-button>

                    </td>
                  </tr>
                  <tr v-if="!cajas">
                    <td  class="text-center" colspan="6"> <h2>No hay Información</h2></td>
                  </tr>
                </tbody></table>
            
              <!-- /.card-body 
              <div class="card-footer">
                  <pagination :data="cajas" @pagination-change-page="getResults"></pagination>
              </div>
         -->
            <!-- /.card -->
        </div>
        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination @change="getResults"  v-model="currentPage" :per-page="perPage" :total="totalItemsRow"></base-pagination>
        </b-card-footer>
    </b-card>          
          <!--<light-table/>          
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>



  <b-modal id="modal-multi-3" ref="modal-multi-3" size="sm" title="Turnos Procesados" ok-only>
    <p class="my-1">Los turnos Ya fueron Procesados</p>
  </b-modal>

    <!-- Detalle pago -->
    <b-modal ref="modal-Detalle" hide-backdrop  size="xl" ok-only>
      <template #modal-title>
        <h5 class="modal-title">Detalles Pagos</h5>        
      </template>
      <p>
        <!--Total Dolares: {{detalleMoneda[0].totalMoneda | moneda}} - Total Bolivares: {{detalleMoneda[1].totalMoneda | moneda}}-->
        <b-button v-b-modal.modal-multi-3 size="sm">Open Third Modal</b-button>
      </p>
      <template #modal-footer="{ close }">
        <div class="w-100">          
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="close()"
          >
            Cerrar
          </b-button>
        </div>
      </template>
    </b-modal>  

    <b-modal id="modalArqueoCaja" ref="modalArqueoCaja" size="xl"  hide-footer>
        <template #modal-title>
            <h2 class="modal-title" v-show="!editmode" id="addNewLabel">Cierre de Caja: {{cajaSelected.codigoCaja}}</h2>
            <h2 class="modal-title" v-show="editmode" id="addNewLabel">Actualizar Cierre de Caja: {{cajaSelected.codigoCaja}}</h2>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <b-row><!--Detalle de Arqueo-->
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Fecha:
                    <b-badge variant="primary">{{cajaSelected.fecha | myDate}}</b-badge>
                      <!--<b-form-input class="form-control" :disabled="deshabilitadoFecha" size="sm" v-model="filtro.fecha" type="date" value="2021-01-04" id="fecha"></b-form-input>-->
                  </b-list-group-item>
                </b-list-group>                
              </b-col>
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">                   
                    Caja: 
                    <b-badge variant="primary">{{cajaSelected.codigoCaja}}</b-badge>
                  </b-list-group-item>
                </b-list-group>                
              </b-col>              
              <!--<b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Inicio:
                    <b-badge variant="primary" pill>{{form.inicio | myTime}} </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Fin: 
                    <b-badge variant="primary" pill>{{form.fin | myTime}}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>-->
            </b-row>
            <hr class="my-3">
            <b-row>
              <b-col xl="8" md="8">
                <b-card no-body>
                  <table class="table table-striped" >
                    <tr>
                      <th scope="row">&nbsp;</th>
                      <td>Procesado por sistema</td>
                      <td><b>Declarado Caja</b></td>
                    </tr>
                    <tr>
                    <tr>
                      <th scope="row">----</th>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr v-for="mdfp in masterDetalleFP.procesado" :key="mdfp.formaPagoId">
                      <th scope="row">{{mdfp.descripcion}}</th>
                      <td class="text-right procesado">{{mdfp.monto| moneda}}</td>
                      <td class="text-right declarado">{{ searchMontoDec(mdfp)| moneda}}</td>
                    </tr>
                    <tr class="bckgbs">
                      <th scope="row">Total Bs</th>
                      <td class="text-right textMontoG">{{totalGeneralMDBs | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoBs | moneda}}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="bckgnormal">{{ faltaOSobra(totalGeneralSCBs,totalFacturadoBs) }}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="text-right textMontoG" :class="{'bckgfaltante':(totalGeneralSCBs-totalFacturadoBs)<0, 'bckgsobrante':(totalGeneralSCBs-totalFacturadoBs)>0}">{{(totalGeneralSCBs-totalFacturadoBs)| moneda}}</td>
                    </tr>
                    <tr class="bckgdolar">
                      <th scope="row">Total Dolar</th>
                      <td class="text-right textMontoG">{{totalGeneralMDDolar | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoDolar | moneda}}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="bckgnormal">{{ faltaOSobra(totalGeneralSCDolar, totalFacturadoDolar) }}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="text-right textMontoG" :class="{'bckgfaltante':(totalGeneralSCDolar-totalFacturadoDolar)<0, 'bckgsobrante':(totalGeneralSCDolar-totalFacturadoDolar)>0}">  {{(totalFacturadoDolar-totalGeneralSCDolar) | moneda}}</td>
                    </tr>
                    <!--<tr>
                      <th>Total General Turno</th>
                      <td class="text-right textMontoG">{{cajaSelected.totalfacturadobs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{cajaSelected.totalfacturadodolar | moneda}} $</td>
                    </tr>
                    <tr>
                      <th>Total General </th>
                      <td class="text-right textMontoG">{{acumBs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{acumDolar | moneda}} $</td>
                    </tr> -->                   
                  </table>                                
                </b-card>
              </b-col>
              <b-col xl="4" md="4">
                <!-- Tabs Tipos de Pago -->
                <b-row>
                  <!--<b-form-select :class="{'disable':this.selectTipoPago.length-1==0}" class="col-3" v-model="tipoPago" size="sm" :options="selectTipoPago"></b-form-select>
                  <b-button v-if="cajaSelected.estatus!==4 && cajaSelected.estatus!==5" @click="validarMontos()" class="col-2" size="sm"><i class="fas fa-plus"></i></b-button>-->
                  <b-button @click="verComentario()" class="col-2" size="sm"><i class="fas fa-comment-dots"></i></b-button>
                  <b-button v-if="cajaSelected.estatus!==4 && cajaSelected.estatus!==5" class="col-2" ><i class="fas fa-eraser"></i></b-button>
                  
                  <b-button v-if="(esGuardado || cajaSelected.estatus===4) && $gate.isAllAdminOrUsers()" @click="validarArqueo(cajaSelected)" class="col-2" variant="success" ><i class="fas fa-check-double"></i></b-button>
                  <b-button v-if="!esGuardado && (cajaSelected.estatus!==4 && cajaSelected.estatus!==5)" @click="guardarArqueo()" class="col-2" variant="success" ><i class="fas fa-cash-register"></i></b-button>
                  <b-button v-if="esGuardado || cajaSelected.estatus===4" @click="imprimirArqueo()" class="col-2" variant="info" ><i class="fas fa-print"></i></b-button>
                  <b-button  class="col-2" variant="danger" @click="cerrarViewArqueo()"><i class="fas fa-sign-out-alt"></i></b-button>
                </b-row>
                <hr class="my-3">
                <b-row xl="12" md="12">
                  <b-card no-body>
                    <b-list-group>
                      <b-list-group-item  v-for="mp in  metodoPagos" :key="mp.value" class="d-flex justify-content-between align-items-center">
                        <b-button @click="verDetallePago(mp)"  variant="info" size="sm">{{mp.value}} - {{mp.nombre}}</b-button>
                        <b-badge variant="primary" ><b-form-input :ref="'inputx_'+mp.value"  class="form-control" size="sm" v-model="mp.monto" type="text" placeholder="0" :id="'monto_'+mp.value"></b-form-input></b-badge>
                      </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
                    </b-list-group>                  
                  </b-card>
                </b-row>                
              </b-col>
            </b-row>
          </form>
    </b-modal>

    <!-- Observaciones -->
    <b-modal ref="modal-Observaciones" size="sm" title="Agregar Observaciones" ok-only>
      <b-form-textarea
      id="textarea"
      v-model="form.observacion"
      placeholder="Ingrese Observaciones..."
      rows="3"
      max-rows="6"
      ></b-form-textarea>
    </b-modal>

    <!--cierreTotal -->
    <b-modal id="modalCierreTotal" ref="modalCierreTotal" size="xl"  hide-footer>
        <template #modal-title>
            <h2 class="modal-title" v-show="!editmode" id="addNewLabel">Cierre de Caja Día: </h2>
            <h2 class="modal-title" v-show="editmode" id="addNewLabel">Actualizar Cierre de Caja:</h2>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <b-row><!--Detalle de Arqueo-->
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Fecha:
                    <b-badge variant="primary">{{cajaSelected.fecha | myDate}}</b-badge>
                      <!--<b-form-input class="form-control" :disabled="deshabilitadoFecha" size="sm" v-model="filtro.fecha" type="date" value="2021-01-04" id="fecha"></b-form-input>-->
                  </b-list-group-item>
                </b-list-group>                
              </b-col>
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">                   
                    Caja: 
                    <b-badge variant="primary">Todas</b-badge>
                  </b-list-group-item>
                </b-list-group>                
              </b-col>              
              <!--<b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Inicio:
                    <b-badge variant="primary" pill>{{form.inicio | myTime}} </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Fin: 
                    <b-badge variant="primary" pill>{{form.fin | myTime}}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>-->
            </b-row>
            <hr class="my-3">
            <b-row>
              <b-col xl="8" md="8">
                <b-card no-body>
                  <table class="table table-striped" >
                    <tr>
                      <th scope="row">&nbsp;</th>
                      <td>Procesado por sistema</td>
                      <td><b>Declarado Caja</b></td>
                    </tr>
                    <tr>
                    <tr>
                      <th scope="row">----</th>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr v-for="mdfp in masterDetalleFP.procesado" :key="mdfp.formaPagoId">
                      <th scope="row">{{mdfp.descripcion}}</th>
                      <td class="text-right procesado">{{mdfp.monto| moneda}}</td>
                      <td class="text-right declarado">{{ searchMontoDec(mdfp)| moneda}}</td>
                    </tr>
                    <tr class="bckgbs">
                      <th scope="row">Total Bs</th>
                      <td class="text-right textMontoG">{{totalGeneralMDBs | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoBs | moneda}}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="bckgnormal">{{ faltaOSobra(totalGeneralSCBs,totalFacturadoBs) }}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="text-right textMontoG" :class="{'bckgfaltante':(totalGeneralSCBs-totalFacturadoBs)<0, 'bckgsobrante':(totalGeneralSCBs-totalFacturadoBs)>0}">{{(totalGeneralSCBs-totalFacturadoBs)| moneda}}</td>
                    </tr>
                    <tr class="bckgdolar">
                      <th scope="row">Total Dolar</th>
                      <td class="text-right textMontoG">{{totalGeneralMDDolar | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoDolar | moneda}}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="bckgnormal">{{ faltaOSobra(totalGeneralSCDolar, totalFacturadoDolar) }}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="text-right textMontoG" :class="{'bckgfaltante':(totalGeneralSCDolar-totalFacturadoDolar)<0, 'bckgsobrante':(totalGeneralSCDolar-totalFacturadoDolar)>0}">  {{(totalFacturadoDolar-totalGeneralSCDolar) | moneda}}</td>
                    </tr>
                    <!--<tr>
                      <th>Total General Turno</th>
                      <td class="text-right textMontoG">{{cajaSelected.totalfacturadobs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{cajaSelected.totalfacturadodolar | moneda}} $</td>
                    </tr>
                    <tr>
                      <th>Total General </th>
                      <td class="text-right textMontoG">{{acumBs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{acumDolar | moneda}} $</td>
                    </tr> -->                   
                  </table>                                
                </b-card>
              </b-col>
              <b-col xl="4" md="4">
                <!-- Tabs Tipos de Pago -->
                <b-row>
                  <!--<b-form-select :class="{'disable':this.selectTipoPago.length-1==0}" class="col-3" v-model="tipoPago" size="sm" :options="selectTipoPago"></b-form-select>
                  <b-button v-if="cajaSelected.estatus!==4 && cajaSelected.estatus!==5" @click="validarMontos()" class="col-2" size="sm"><i class="fas fa-plus"></i></b-button>-->
                  <b-button @click="verComentario()" class="col-2" size="sm"><i class="fas fa-comment-dots"></i></b-button>
                  <b-button v-if="cajaSelected.estatus!==4 && cajaSelected.estatus!==5" class="col-2" ><i class="fas fa-eraser"></i></b-button>
                  
                  <b-button v-if="(esGuardado || cajaSelected.estatus===4) && $gate.isAllAdminOrUsers()" @click="validarArqueo(cajaSelected)" class="col-2" variant="success" ><i class="fas fa-check-double"></i></b-button>
                  <b-button v-if="!esGuardado && (cajaSelected.estatus!==4 && cajaSelected.estatus!==5)" @click="guardarArqueo()" class="col-2" variant="success" ><i class="fas fa-cash-register"></i></b-button>
                  <b-button v-if="esGuardado || cajaSelected.estatus===4" @click="imprimirArqueo()" class="col-2" variant="info" ><i class="fas fa-print"></i></b-button>
                  <b-button  class="col-2" variant="danger" @click="cerrarViewCajasTotal()"><i class="fas fa-sign-out-alt"></i></b-button>
                </b-row>
                <hr class="my-3">
                <b-row xl="12" md="12">
                  <b-card no-body>
                    <b-list-group>
                      <b-list-group-item  v-for="mp in  metodoPagos" :key="mp.value" class="d-flex justify-content-between align-items-center">
                        <b-button @click="verDetallePago(mp)"  variant="info" size="sm">{{mp.value}} - {{mp.nombre}}</b-button>
                        <b-badge variant="primary" ><b-form-input :ref="'inputx_'+mp.value"  class="form-control" size="sm" v-model="mp.monto" type="text" placeholder="0" :id="'monto_'+mp.value"></b-form-input></b-badge>
                      </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
                    </b-list-group>                  
                  </b-card>
                </b-row>                
              </b-col>
            </b-row>
          </form>
    </b-modal>
    <!-- Cierre turnos -->
    <!--cierreTotal -->
    <b-modal id="modalTurnosProcesados" ref="modalTurnosProcesados" size="xl"  hide-footer>
        <template #modal-title>
            <h2 class="modal-title" v-show="!editmode" id="addNewLabel">Turnos Procesados Caja Adm:</h2>
            <h2 class="modal-title" v-show="editmode" id="addNewLabel">---</h2>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <b-row><!--Detalle de Arqueo-->
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Fecha:
                    <b-badge variant="primary">{{cajaSelected.fecha | myDate}}</b-badge>
                      <!--<b-form-input class="form-control" :disabled="deshabilitadoFecha" size="sm" v-model="filtro.fecha" type="date" value="2021-01-04" id="fecha"></b-form-input>-->
                  </b-list-group-item>
                </b-list-group>                
              </b-col>
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">                   
                    Caja: 
                    <b-badge variant="primary">{{cajaSelected.codigoCaja}}</b-badge>
                  </b-list-group-item>
                </b-list-group>                
              </b-col>              
              <!--<b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Inicio:
                    <b-badge variant="primary" pill>{{form.inicio | myTime}} </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Hora Fin: 
                    <b-badge variant="primary" pill>{{form.fin | myTime}}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>-->
            </b-row>
            <hr class="my-3">
            <b-row>
              <b-col xl="8" md="8">
                <b-card no-body>
                  <table class="table table-striped" >
                    <tr>
                      <th scope="row">&nbsp;</th>
                      <td>Procesado por sistema</td>
                      <td><b>Declarado Caja</b></td>
                    </tr>
                    <tr>
                    <tr>
                      <th scope="row">----</th>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr v-for="mdfp in masterDetalleFP.procesado" :key="mdfp.formaPagoId">
                      <th scope="row">{{mdfp.descripcion}}</th>
                      <td class="text-right procesado">{{mdfp.monto| moneda}}</td>
                      <td class="text-right declarado">{{ searchMontoDec(mdfp)| moneda}}</td>
                    </tr>
                    <tr class="bckgbs">
                      <th scope="row">Total Bs</th>
                      <td class="text-right textMontoG">{{totalGeneralMDBs | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoBs | moneda}}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="bckgnormal">{{ faltaOSobra(totalGeneralSCBs,totalFacturadoBs) }}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="text-right textMontoG" :class="{'bckgfaltante':(totalGeneralSCBs-totalFacturadoBs)<0, 'bckgsobrante':(totalGeneralSCBs-totalFacturadoBs)>0}">{{(totalGeneralSCBs-totalFacturadoBs)| moneda}}</td>
                    </tr>
                    <tr class="bckgdolar">
                      <th scope="row">Total Dolar</th>
                      <td class="text-right textMontoG">{{totalGeneralMDDolar | moneda}}</td>
                      <td class="text-right textMontoG">{{totalFacturadoDolar | moneda}}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="bckgnormal">{{ faltaOSobra(totalGeneralSCDolar, totalFacturadoDolar) }}</td>
                      <td v-if="cajaSelected.estatus===4 || cajaSelected.estatus===5" class="text-right textMontoG" :class="{'bckgfaltante':(totalGeneralSCDolar-totalFacturadoDolar)<0, 'bckgsobrante':(totalGeneralSCDolar-totalFacturadoDolar)>0}">  {{(totalFacturadoDolar-totalGeneralSCDolar) | moneda}}</td>
                    </tr>
                    <!--<tr>
                      <th>Total General Turno</th>
                      <td class="text-right textMontoG">{{cajaSelected.totalfacturadobs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{cajaSelected.totalfacturadodolar | moneda}} $</td>
                    </tr>
                    <tr>
                      <th>Total General </th>
                      <td class="text-right textMontoG">{{acumBs | moneda}} Bs</td>
                      <td class="text-right textMontoG">{{acumDolar | moneda}} $</td>
                    </tr> -->                   
                  </table>                                
                </b-card>
              </b-col>
              <b-col xl="4" md="4">
                <!-- Tabs Tipos de Pago -->
                <b-row>
                  <!--<b-form-select :class="{'disable':this.selectTipoPago.length-1==0}" class="col-3" v-model="tipoPago" size="sm" :options="selectTipoPago"></b-form-select>
                  <b-button v-if="cajaSelected.estatus!==4 && cajaSelected.estatus!==5" @click="validarMontos()" class="col-2" size="sm"><i class="fas fa-plus"></i></b-button>-->
                  <b-button @click="verComentario()" class="col-2" size="sm"><i class="fas fa-comment-dots"></i></b-button>
                  <b-button v-if="cajaSelected.estatus!==4 && cajaSelected.estatus!==5" class="col-2" ><i class="fas fa-eraser"></i></b-button>
                  
                  <b-button v-if="(esGuardado || cajaSelected.estatus===4) && $gate.isAllAdminOrUsers()" @click="validarArqueo(cajaSelected)" class="col-2" variant="success" ><i class="fas fa-check-double"></i></b-button>
                  <b-button v-if="!esGuardado && (cajaSelected.estatus!==4 && cajaSelected.estatus!==5)" @click="guardarArqueo()" class="col-2" variant="success" ><i class="fas fa-cash-register"></i></b-button>
                  <b-button v-if="esGuardado || cajaSelected.estatus===4" @click="imprimirArqueo()" class="col-2" variant="info" ><i class="fas fa-print"></i></b-button>
                  <b-button  class="col-2" variant="danger" @click="cerrarModalTurnosProcesados()"><i class="fas fa-sign-out-alt"></i></b-button>
                </b-row>
                <hr class="my-3">
                <b-row xl="12" md="12">
                  <b-card no-body>
                    <b-list-group>
                      <b-list-group-item  v-for="mp in  metodoPagos" :key="mp.value" class="d-flex justify-content-between align-items-center">
                        <b-button @click="verDetallePago(mp)"  variant="info" size="sm">{{mp.value}} - {{mp.nombre}}</b-button>
                        <b-badge variant="primary" ><b-form-input :ref="'inputx_'+mp.value"  class="form-control" size="sm" v-model="mp.monto" type="text" placeholder="0" :id="'monto_'+mp.value"></b-form-input></b-badge>
                      </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
                    </b-list-group>                  
                  </b-card>
                </b-row>                
              </b-col>
            </b-row>
          </form>
    </b-modal>
    
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    components: {
      //LightTable,
      //DarkTable,
      //Modal,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      selected:-1,
      selectEdo:{},
      TipoElectSeleccionado:0,
      detalleBancos:false,
      detalleTarjetas:false,
      detalleEfectivo:false,
      //-------------------
      bancos:[],
      dataCajera:{},
      cajaSelected:{},
      montoValidado:false,
      esGuardado:false,
      montoActual:0,
      totalBancoTT:0,
      totalFacturadoBs:0,
      totalFacturadoDolar: 0,
      impresionCierre:[],
      acumBs: 0,
      acumDolar:0,
      perPage:10,
      currentPage: 1,
      totalItemsRow:10,      
      //======================
      form: new Form({
        id: 0,
        tiendaId: 0,
        codigoCaja: '',
        areaId: '',
        monto: 0,
        observacion:'',
        estatus: true,
      }),
      filtro: new Form({
        nroFactura: '',
        Caja: '',
        nroDocumento: '',
        nombreCajera:'',
        Turno: 0,
        fecha: this.getDate(),
        //fechaF: this.getDate(),
        monto: 0,
        estatus: "-1",
      }),
        cajas:[],
        detalleMoneda:[],
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
        factMayor: [{value:true, text:"Si"}, {value:false, text:"No"}],
        selectTienda:[{value:-1, text:"Seleccione"}],
        ResumenPagos:[
            {id:1, pagoElectronico: [ {tipo:"TDD", monto:122100}, {tipo:"TDC", monto: 171900}]},
            {id:2, Efectivo:[ {tipo:"Dolares", monto: 400}, {tipo:"Bolivares", bolivares: 200000}]},
            {id:3, otros:[ {tipo:"Zelle", monto: 150}, {tipo:"WalletRio", monto:0}]}
          
        ],
        selectTipoPago:[{value:"", text:"Seleccione"},{value:"1", text:"Efectivo Bs"},{value:"2", text:"Efectivo Dolar"},{value:"3", text:"Punto Interno"},{value:"4", text:"Wallet $."},{value:"5", text:"Vuelto Efectivo $."},{value:"6", text:"Pago Zelle"}, {value:"7", text:"Punto Externo"}, {value:"8", text:"TDC Int"},{value:"9", text:"TDD Int"}],
        metodoPagos:[],//metodos de pagos        
        masterDetalleFP:[],
        detalleEfectivoDolar:[{denom:1, cantidad:0, monto:0},{denom:5, cantidad:0, monto:0},{denom:10, cantidad:0, monto:0},{denom:20, cantidad:0, monto:0},{denom:50, cantidad:0, monto:0},{denom:100, cantidad:0, monto:0}],
        detalleBantoTipoTarjeta:[],
        variantesLG:[{id:1,variante:"success"},{id:2,variante:"warning"},{id:3,variante:"secondary"}]      };
    },
    methods: {
      async getResults(page = 1) {
        await axios.get(this.$gate.getApiUrl()+'CajaAdministrativa/FacturadoXCajaXFecha?page='+page+'&perPage='+this.perPage,{ params: this.filtro })
        .then(({ data }) => {
          if(data.data){
            this.cajas = data.data.cajas;
            this.totalItemsRow = data.data.totalrow;
          }else{
            this.cajas =[];
          }
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }
        });
      },
      getDate(){
        var currentDate = new Date();
        return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
      },
      aplicarFiltro(){
        //if(this.$gate.isAdmin()){
          let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: true,
            loader: 'dots',
          });
          this.getResults();
          loader.hide();     
      },       
      resetFiltro(){
        this.filtro.reset();      
        this.filtroActivo = false;
      },
      onFiltroChange(){
        this.filtroActivo = true;
      },       
      async turnosProcesados(){
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/ReporteCierreTurnos/fecha/"+this.filtro.fecha).then(({ data }) => {
          this.masterDetalleFP = data.data;
          });

          console.log(this.masterDetalleFP)

        if(this.masterDetalleFP.procesado > 0){
          this.$refs['modalTurnosProcesados'].show();
        }else{
          this.$refs['modal-multi-3'].show();
        }
        
      },      
      async cierreTotal(){
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/ReporteCierreCaja/fecha/"+this.filtro.fecha+"/caja/0").then(({ data }) => {
          this.masterDetalleFP = data.data;
          });
        
        this.$refs['modalCierreTotal'].show();
      },
      cerrarModalTurnosProcesados(){
        Fire.$emit('AfterCreate');
        this.$refs['modalTurnosProcesados'].hide();
      },
      cerrarViewCajasTotal(){
        Fire.$emit('AfterCreate');
        this.$refs['modalCierreTotal'].hide();
      },      
      mostrarDetalleBancos(){
        this.detalleBancos =true;
      },
      mostrarTipoSelec(tipoPago){        
        this.detalleTarjetas = this.detalleTarjetas?false:true;
        this.TipoElectSeleccionado = tipoPago=="TDD"?1:2;
      },
      searchMontoDec(mdfp){
        
        let dataDeclarado = this.masterDetalleFP.declarado.find( mdp => mdp.formaPagoId === mdfp.formaPagoId);
        //console.log(this.masterDetalleFP.declarado[ind])
        //let mio = objMasterDetalle.find(n => n.origen == mdfp.descripcion);
        return  (dataDeclarado)?dataDeclarado.monto:0;
        //return mio.monto;

      },
      async detalleCaja(caja){
        this.cajaSelected = caja;
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/ReporteCierreCaja/fecha/"+this.filtro.fecha+"/caja/"+caja.codigoCaja).then(({ data }) => {
          this.masterDetalleFP = data.data;
          });
        
        this.$refs['modalArqueoCaja'].show();
      },
      procesarCaja(caja){
        this.$router.push("turnos?Caja="+caja.codigoCaja+"&fecha="+this.filtro.fecha);
      },
      editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        //console.log(caja);
        this.form.fill(caja);
      },
      updateCaja(){
        console.log('Actualizar Data');
        this.hideModal();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      createCaja(){

      },
      totalDetalle(pagoFacturaElectronico){

      },
      /*bancoAdquiriente(bancoId){
        let itemEnc = this.bancos.find(m => m.id === bancoId);
        return itemEnc?itemEnc.nombre:"---"
      },
      getTienda(tiendaId){
        
        if(this.tiendas.length >0){
          let itemEnc = this.tiendas.find(m => m.id === tiendaId);
          if(tiendaId>=0){
            return itemEnc.nombre;
          }else{ 
            return "---";
          }
        }
      },*/
      buscarDatos: async function(){
        //await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/FacturadoXCajaXFecha?fechaActual="+this.filtro.fecha).then(({ data }) => {this.cajas = data.data; });
      },
      loadCajas: async function(){       
        //if(this.$gate.isAdminOrAuthor()){
          this.filtro.fecha = this.getDate();
          /*await axios.get(this.$gate.getApiUrl()+"Tienda/SelectTiendas").then(({ data }) => {          
            this.selectTienda = data;
          }).catch( e => {
            console.log(e.response.status)
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }
          });*/
          //terinar esto para mostrar la cajera en turno
          //await axios.get(this.$gate.getApiUrl()+"Usuario/turno?fechaActual="+this.filtro.fecha).then(({ data }) => {this.cajas = data.data; });
          this.getResults(); 
          //await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/FacturadoXCajaXFecha?fechaActual="+this.filtro.fecha).then(({ data }) => {this.cajas = data.data; });
          //axios.get("http://localhost/security/data/facturadoxcaja.json?fechaActual="+this.filtro.fecha).then(({ data }) => {this.cajas = data.data; });
          
        //}
      },

    },
    mounted(){
      this.loadCajas();
    },
    created(){
      
    },
    computed: {
      totalGeneralDBTT: function(){
        let total = [];

        Object.entries(this.detalleBantoTipoTarjeta).forEach(([key, val]) => {
           //if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(parseFloat(val.monto)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralDed: function(){
        let total = [];

        Object.entries(this.detalleEfectivoDolar).forEach(([key, val]) => {
           //if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralMDBs: function(){

        let total = [];

        Object.entries(this.masterDetalleFP).forEach(([key, val]) => {
           if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(val.totalFormaPago) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralMDDolar: function(){

        let total = [];

        Object.entries(this.masterDetalleFP).forEach(([key, val]) => {
           if(val.formaPagoId==2 || val.formaPagoId==4 || val.formaPagoId==5 || val.formaPagoId==6)
            total.push(val.totalFormaPago) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralSCBs: function(){

        let total = [];

        Object.entries(this.metodoPagos).forEach(([key, val]) => {
           if(val.value==1 || val.value==3 || val.value==7)
            total.push((val.monto!=="")?parseFloat(val.monto):0) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralSCDolar: function(){

        let total = [];

        Object.entries(this.metodoPagos).forEach(([key, val]) => {      
           if(val.value==2 || val.value==4 || val.value==5 || val.value==6){
             //val.monto = 
            total.push((val.monto!=="")?(val.formaPagoId==4)?(-1 * parseFloat(val.monto)):parseFloat(val.monto):0) // the value of the current key.
           }
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },      
      totalGeneralTurnoBs: function(){

        let total = [];

        Object.entries(this.turnos).forEach(([key, val]) => {           
            total.push(parseFloat(val.totalfacturadobs)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralTurnoDolar: function(){

        let total = [];

        Object.entries(this.turnos).forEach(([key, val]) => {           
            total.push(parseFloat(val.totalfacturadodolar)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },        
      /*
      totalElectronico: function(){

        let total = [];

        Object.entries(this.pagoFacturaElectronico).forEach(([key, val]) => {
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalBanco: function(){
        let total = [];
        Object.entries(this.detalleBanco).forEach(([key, val]) => {
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);
      },
      totalGeneralElec: function(){
        let total = [];
        Object.entries(this.detalleBanco).forEach(([key, val]) => {
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);
      } */     
    },    
  };
</script>
<style>
.scrollDiv{
  	overflow-y: scroll;
    	height: 300px;
	
}
.bckgcard{
  background: #fff;
}
.barralateral{
  border-right: 1px solid #d2d6de;
}
a {
color:#1D7F31
}
 .declarado{
   background: #f5f5f5;
   font-weight: bold;
 }
  .procesado{
   background: #dff5d2;
   font-weight: bold;
 }
 .bckgdolar{
   background:#c4f1de;
 }
 .bckgbs{
   background: #bcf1fb;
 }
.bckgfaltante{
   background: #fac7c7;
 }
 .bckgsobrante{
   background: #faf2c7;
 }
</style>